// extracted by mini-css-extract-plugin
module.exports = {"Message_pop_up":"MessagePopUp_Message_pop_up__1KIP_"};